import { connect } from 'react-redux';
import { getMe } from './../actions/Users';
import { getList as getPosts } from './../actions/Posts';
import { getList as getColors } from './../actions/Colors';
import { getList as getFilters } from './../actions/Filters';
import { getList as getHashtags } from './../actions/Hashtags';
import Content from './../components/Content';

export default connect(null, { getMe, getPosts, getColors, getFilters, getHashtags })(Content);
